import { render, staticRenderFns } from "./DefaultHeader.vue?vue&type=template&id=807d2758&scoped=true"
import script from "./DefaultHeader.vue?vue&type=script&lang=js"
export * from "./DefaultHeader.vue?vue&type=script&lang=js"
import style0 from "./DefaultHeader.vue?vue&type=style&index=0&id=807d2758&prod&lang=scss&scoped=true"
import style1 from "./DefaultHeader.vue?vue&type=style&index=1&id=807d2758&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807d2758",
  null
  
)

export default component.exports